(function () {
    'use strict';

    angular.module("imApp").factory("stockCountResultService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3452,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
